import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import CustomersCreateHeader from '../components/leadsViewCreate/LeadsViewHeader'
import CustomerCreateContent from '../components/customers/TrashCustomerTable'

const CustomersCreate = () => {
    return (
        <>
            <PageHeader>
                <CustomersCreateHeader />
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <CustomerCreateContent />
                </div>
            </div>
        </>
    )
}

export default CustomersCreate